module.exports = __webpack_public_path__ + "img/turkmenistan.7f458b4c.svg";